import { Box, Tag, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'

import { useTrainingsDatatable } from 'modules/trainings/hooks/useTrainingsDatatable'

const CompletionTag = ({ dueDate }: { dueDate: string }) => {
  const [openTooltip, toggleTooltip] = useToggle()
  const { getDueDateText, getDueDateTagColor } = useTrainingsDatatable()

  const tagText = getDueDateText(dueDate)
  const tagColor = getDueDateTagColor(dueDate)
  const formatedDate = i18nDateToString(
    stringToDate(dueDate, 'backend_datetime'),
    'ui_abbreviated_month_year'
  )

  return (
    <Box width="fit-content">
      <Tooltip.Dialog
        label={formatedDate}
        attachment="bottom left"
        open={openTooltip}
        toggle={toggleTooltip}
      >
        <Tag type={tagColor}>{tagText}</Tag>
      </Tooltip.Dialog>
    </Box>
  )
}

export default CompletionTag
